/**
 * This file contains all the routes of the application.
 */
export const Routes = {
  kids: () => `/kids`,
  kidHome: (kidSlug: string) => `/kid?kidslug=${kidSlug}`,
  entry: (kidSlug: string) => `/entry?kidslug=${kidSlug}`,
  entry_route: () => `/entry`,
  kidHome_route: () => `/kid`,
  moments: (kidSlug: string) => `/kid/moments?kidslug=${kidSlug}`,
  momentsPrint: (kidSlug: string) => `/kid/moments/print?kidslug=${kidSlug}`,
  moments_route: () => `/kid/moments`,
  moods_checkins: (kidSlug: string) => `/moods_checkins?kidslug=${kidSlug}`,
  moods_checkins_route: () => `/moods_checkins`,
  checklist: (kidSlug: string) => `/kid/checklist?kidslug=${kidSlug}`,
  timeline: (kidSlug: string) => `/kid/timeline?kidslug=${kidSlug}`,
  dailySummary: (kidSlug: string) => `/kid/daily-summary?kidslug=${kidSlug}`,
  sleep: (kidSlug: string) => `/kid/sleep?kidslug=${kidSlug}`,
  sleep_route: () => `/kid/sleep`,
  diaper_route: () => `/kid/diaper`,
  feeding_route: () => `/kid/feeding`,
  diaper: (kidSlug: string) => `/kid/diaper?kidslug=${kidSlug}`,
  activity: (kidSlug: string) => `/kid/activity?kidslug=${kidSlug}`,
  activity_route: () => `/kid/activity`,
  feeding: (kidSlug: string) => `/kid/feeding?kidslug=${kidSlug}`,
  chart: (kidSlug: string) => `/kid/chart?kidslug=${kidSlug}`,
  chart_route: () => `/kid/chart`,
  manageKid: (kidSlug: string) => `/kid/manage?kidslug=${kidSlug}`,
} as const;
